/**
 * 页面限制操作工具
 * 限制：刷新快捷键、Alt前进后退、浏览器返回按钮、右键、页面刷新关闭提醒、路由离开弹窗
 */

export default {
  // 绑定所有监听
  bind(vm) {
    // 挂载vue实例
    this.vm = vm
    // 拦截浏览器返回按钮 popstate
    history.pushState(null, null, location.href)
    window.addEventListener('popstate', this.handlePopBack.bind(this))
    // 刷新/关闭页面监听
    window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this))
    // 键盘快捷键拦截
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
    // 禁用右键菜单
    // document.addEventListener('contextmenu', this.disableRightClick.bind(this))
  },

  // 销毁移除监听（页面销毁必须调用）
  unbind() {
    window.removeEventListener('popstate', this.handlePopBack.bind(this))
    window.removeEventListener('beforeunload', this.handleBeforeUnload.bind(this))
    document.removeEventListener('keydown', this.handleKeyDown.bind(this))
    // document.removeEventListener('contextmenu', this.disableRightClick.bind(this))
  },

  // 浏览器左上角返回按钮拦截
  handlePopBack() {
    history.pushState(null, null, location.href)
    this.vm.$uni.showToast({ title: '禁止后退操作', icon: 'none' })
  },

  // 页面刷新、关闭标签弹窗提示
  handleBeforeUnload(e) {
    // dirty 为页面未保存标记，取自vue实例data
    if (!this.vm.dirty) return
    const warnText = '当前页面数据未保存，刷新或关闭页面会丢失内容'
    e.returnValue = warnText
    return warnText
  },

  // 键盘拦截：F5/Ctrl+R刷新、Alt左右前进后退、F12
  handleKeyDown(e) {
    const code = e.keyCode || e.which
    // F5 / Ctrl+R 刷新
    if (code === 116 || (e.ctrlKey && code === 82)) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
    // Alt + ← 后退
    if (e.altKey && code === 37) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
    // Alt + → 前进
    if (e.altKey && code === 39) {
      e.preventDefault()
      e.stopPropagation()
      return false
    }
    // 屏蔽F12调试
    if (code === 123) {
      e.preventDefault()
    }
  },

  // 禁用鼠标右键菜单
  disableRightClick(e) {
    e.preventDefault()
    return false
  },

  // 路由离开校验方法，放在页面beforeRouteLeave中调用
  routeLeaveCheck(to, from, next) {
    const isFormal = localStorage.getItem('isFormal')
    if (isFormal === '0' && this.vm.dirty) {
      this.vm.$uni.showModal({
        title: '提示',
        content: '页面数据未保存，确认离开？',
        success: res => {
          res.confirm ? next() : next(false)
        }
      })
    } else {
      next()
    }
  }
}
